import React, { useEffect } from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { User } from "lucide-react";
import logo from "../assets/images/logo.png";
import { useAuth } from "../contexts/AuthContext";
import LanguageSwitcher from "./common/languageSwitcher";
import useUserStore from "../stores/useUserStore";

export const NavBar = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { logout } = useAuth();
  const { user, initializeFromSession } = useUserStore();

  // Inicializar el store desde sessionStorage al montar
  useEffect(() => {
    initializeFromSession();
  }, [initializeFromSession]);

  function handleLogout() {
    logout();
    navigate("/");
  }

  return (
    <Navbar bg="light" expand="lg">
      <Container className="d-flex align-items-center">
        <img className="logo" src={logo} alt="GIRS Logo" />
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <div className="w-100 d-flex align-items-center justify-content-between">
            <div className="flex-fill d-flex justify-content-center">
              {user.image ? (
                <div
                  style={{
                    width: "150px",
                    height: "60px",
                    borderRadius: "8px",
                    overflow: "hidden",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "transparent",
                  }}
                >
                  <img
                    src={user.image}
                    alt="Client"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                    }}
                  />
                </div>
              ) : (
                <div
                  className="bg-secondary d-flex align-items-center justify-content-center"
                  style={{
                    width: "150px",
                    height: "60px",
                    borderRadius: "8px",
                  }}
                >
                  <User size={28} color="white" />
                </div>
              )}
            </div>
            <div className="d-flex align-items-center gap-3">
              <Nav>
                <Nav.Link onClick={handleLogout}>{t("nav.logout")}</Nav.Link>
              </Nav>
              <LanguageSwitcher variant="light" />
            </div>
          </div>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};
